import axios from "axios";
import { environment } from "../../environment";
import download from 'js-file-download';

export interface DownloadDto {
  bbCourseId: string,
  bbContentId: string
}

const BASE_URL = `${environment.contentUrl}`;
const DEFAULT_HEADERS = { 'Content-Type': 'application/json' };

class EventsService {

  async getCourses(uid: string) {
    try {
      const path = `${environment.contentUrl}events/courses/user/` + uid;
      const res = await axios.get(path);
      return res?.data
    } catch (err) {
      throw err;
    }
  }

  async getCourse(bbcid: string) {
    try {
      const path = `${environment.contentUrl}events/course/${bbcid}`;
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err;
    }
  }

  async getEvent(id: string) {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const params = { timezone };
      const path = `${environment.contentUrl}events/event/${id}`;
      const res = await axios.get(path, { params });
      return res?.data;
    } catch (err) {
      throw err;
    }
  }

  async getCourseContentAttachment(courseId: string) {
    try {
      const path =
        environment.contentUrl +
        "events/courses/content/" +
        courseId
      const res = await axios.get(path);
      return res?.data ? res.data : [];
    } catch (err) {
      throw err;
    }
  }

  async getEventsByCommunities(communityIds: string[]) {
    try {
      const params = {
        communityIds
      };
      const path = environment.contentUrl + 'events/communities';
      const res = await axios.get(path, { params });
      return res?.data ? res?.data : [];
    } catch (err) {
      throw err;
    }
  }

  async downloadCourseAttachment(downloadDto: DownloadDto, fileName: string) {
    try {
      const params = {
        downloadDto
      };
      const path = environment.contentUrl + 'blackboard/course/attachment/download';
      const res = await axios.get(path, { params });
      if (res?.data) {
        download(res.data.file, fileName, res.data.mimeType);
      }
    } catch (err) {
      throw err;
    }
  }


  ////// Event task functionality

  async getSeminarTasksById(eventId: string, userId: string) {
    try {
      const path = `${environment.contentUrl}events/tasks/${eventId}/${userId}`;
      const res = await axios.get(path);
      return res?.data;
    } catch (err) {
      throw err;
    }
  }

  async cancelBlockSelection(userSelection: any, taskId: string, userId: string, eventId: string, classesIds: string[] = [], blockId?: string) {
    const path = `${environment.contentUrl}events/tasks/cancelRegBlock`;
    const data = {
      userSelection: userSelection,
      taskId: taskId,
      userId: userId,
      eventId: eventId,
      classesIds: classesIds,
      blockId: blockId
    }

    const res: any = await axios.post(path, data, {
      headers: DEFAULT_HEADERS
    });
    return res?.data;
  }



  async createBlockSelection(taskId: string, contactSFId: string, eventId: string, userSelection: string, userId: string, classesIds: string[], blockId?: string) {
    const path = `${BASE_URL}events/tasks/createRegBlock`;
    const data = {
      userSelection: {
        selectedOption: userSelection
      },
      taskId: taskId,
      contactSFId: contactSFId,
      userId: userId,
      eventId: eventId,
      classesIds: classesIds,
      blockId: blockId
    }

    const res: any = await axios.post(path, data, {
      headers: DEFAULT_HEADERS
    });
    return res?.data;
  }

  async createClassOptIn(taskId: string, contactSFId: string, eventId: string, userSelection: string, userId: string, sessionId: string) {
    const path = `${BASE_URL}events/tasks/createClassOptIn`;
    const data = {
      userSelection: {
        selectedOption: userSelection
      },
      taskId: taskId,
      contactSFId: contactSFId,
      userId: userId,
      eventId: eventId,
      sessionId: sessionId
    }

    try {
      const res: any = await axios.post(path, data, {
        headers: DEFAULT_HEADERS
      });
      return res?.data;
    } catch (err) {
      console.error("Error creating class opt in", err);
      throw err;
    }
  }



  async cancelClassOptIn(userSelection: string, contactSFId: string, eventId: string, userId: string, sessionId: string) {

    const path = `${BASE_URL}events/tasks/cancelClassOptIn`;
    const data = {
      userSelection: userSelection,
      contactSFId: contactSFId,
      userId: userId,
      eventId: eventId,
      sessionId: sessionId
    }

    try {
      const res: any = await axios.post(path, data, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      return res?.data;
    } catch (err) {
      console.error("Error canceling class opt in", err);
      throw err;
    }
  }

  async createRankingSelection(taskId: string, contactSFId: string, eventId: string, userSelection: { selectedOption: string, secondOption: string }, userId: string) {
    const path = `${BASE_URL}events/tasks/createRankingSelection`;
    const data = {
      userSelection: userSelection,
      taskId: taskId,
      contactSFId: contactSFId,
      userId: userId,
      eventId: eventId
    }

    const res: any = await axios.post(path, data, {
      headers: DEFAULT_HEADERS
    });
    return res?.data;
  }


}


export default new EventsService() as EventsService;